import { render, staticRenderFns } from "./mycertificate.vue?vue&type=template&id=0aacfb10&"
import script from "./mycertificate.vue?vue&type=script&lang=js&"
export * from "./mycertificate.vue?vue&type=script&lang=js&"
import style0 from "./mycertificate.vue?vue&type=style&index=0&id=0aacfb10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports